import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  error: null,
  loading: false,
  maintenance: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
